import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import AdvancedKidneyCareForABetterLife from "./sections/AdvancedKidneyCareForABetterLife";
import OurSignatureSolutions from "./sections/OurSignatureSolutions";
import VoicesOfExperience from "./sections/VoicesOfExperience";
import BenefitsOfLearning from "./sections/BenefitsOfLearning";
import StartAProject from "./sections/StartAProject";
export default function HomePage() {
  return <main className="min-h-screen overflow-x-hidden bg-white text-slate-900">
      <Header />

      <AdvancedKidneyCareForABetterLife />
      <OurSignatureSolutions />
      <VoicesOfExperience />
      <BenefitsOfLearning />
      <StartAProject />

      <Footer />
    </main>;
}